<template>
  <div class="grid grid-rows-[1fr_auto] h-full overflow-y-hidden md:overflow-y-auto w-full">
    <div class="flex flex-col w-full mb-2 h-full overflow-y-auto px-4 md:px-0">
      <div v-if="privateServices.length > 0" class="w-full flex flex-col md:flex-row md:flex-wrap gap-3 md:gap-6">
        <service-card v-for="service of privateServices"
                      :key="service.id"
                      :service="service"
                      @clicked-edit="clickedEdit"
        />
        <div v-if="isMobile" class="h-4 p-2 flex-none"></div>
      </div>
      <div v-else class="w-full h-max flex flex-col justify-center items-center my-auto">
        <img
          src="../../../../../assets/img/admin/create-services.svg"
          class="w-44 mb-4"
          alt="">
        <span class="text-lg font-medium">נראה שעוד לא יצרתם שירות נסתר</span>
        <span class="text-center px-4 font-light"> שירותים נסתרים הם שירותים שלא יופיעו ללקוחות, ולא ישלחו עליהם תזכורות והודעות, ויאפשרו לכם גמישות בסידור הלוז שלכם. </span>
        <div
          class="relative py-2 px-4 border border-solid m-2 bg-primary-500 text-white rounded-3xl border-purple-800 flex gap-2 justify-center items-center mt-4"
          @click="addNewService">
          <i class="pi pi-verified" />
          <span class="text-sm">הוספת שירות נסתר</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IService, ServiceType } from '@torim-app/types';
import { computed, ref } from 'vue';
import { useAdminStore } from '@app/stores';
import AddOrEditService from '@app/components/admin/modals/AddOrEditService.vue';
import { useDrawer } from '@torim-app/shared-components';
import { useResponsive } from '@app/composables/responsive';
import { trackEvent } from '@app/composables/posthog';

const adminStore = useAdminStore();
const { openDrawer, closeDrawer } = useDrawer();
const { isMobile } = useResponsive();

const selectedServiceToEdit = ref<IService>();

const isMainClient = computed(() => adminStore.getMainClient);
const privateServices = computed<Array<IService>>(() => adminStore.getPrivateServices);

const addNewService = () => {
  trackEvent('add_service_clicked', { source: 'private_services_page', service_type: 'hidden' });
  selectedServiceToEdit.value = undefined;
  openDrawer(AddOrEditService, { serviceType: ServiceType.HIDDEN, service: undefined, mode: 'create', onClose: closeDrawer }, { title: 'הוספת שירות נסתר חדש' });
};

const clickedEdit = (service: IService) => {
  trackEvent('edit_service_clicked', { source: 'private_services_page', service_type: 'hidden' });
  selectedServiceToEdit.value = service;
  openDrawer(AddOrEditService, { serviceType: ServiceType.HIDDEN, service, mode: 'edit', onClose: closeDrawer }, { title: 'עריכת נסתר משלים' });
};


</script>
